export interface IQueryReportResponse{
        htmlFileUrl :string;
        pdfFileUrl : string;
        responseStatus :string;
        responseMessage :string;
        responseDisplay: string;
        savedLocidList:string[];
        locidNoMatch:string[];

       /* constructor(htmlFileUrl: string, pdfFileUrl:string, responseStatus:string, responseMessage:string, responseDisplay:string, savedLocidList:string[], locidNoMatch:string[]){
            this.htmlFileUrl = htmlFileUrl;
            this.pdfFileUrl = pdfFileUrl;
            this.responseStatus =responseStatus;
            this.responseMessage =responseMessage;
            this.responseDisplay = responseDisplay;
            this.savedLocidList= savedLocidList;
            this.locidNoMatch= locidNoMatch;
        }*/
}
export interface IOperation {
    tableName: string;
    displayName: string;
}

export interface IQueryReportListColumnResponse{
    tableDisplay: string;
    fieldName: string;
    displayName: string;
    graphName: string;
    calculated: number;
    styleShow: number;
    graphR: number;
}
export class QueryReportListRequest{
    tableName: string;
    locId: string;
    scenario: number;
    isAdmin: number;
    startYear:number;
    reportId:number;
    columns: IQueryReportListColumnResponse;
    graphType:string;
    scenarioId: number;
}
export class IQueryReportRequest{
    startYear: number;
    scenario:number;
    reportId:number;
    facOption:number;
    locidList:string[];
    constructor(startYear:number, scenario:number, reportId:number, facOption:number, locidList:string[]){
        this.startYear = startYear;
        this.scenario = scenario;
        this.reportId= reportId;
        this.facOption= facOption;
        this.locidList = locidList;
    }
}

export class IQueryReportListComponent{
    id:number;
    name:string;
    constructor(id: number, name: string) {
        this.id=id;
        this.name=name;
    }
}
export class IQueryReportsFacilityRequest{
    locid:string[];
    scenarioId:number;
    constructor(locid:string[], scenario:number){
        this.locid=locid;
        this.scenarioId=scenario;
    }
}



/** WEBPACK FOOTER **
 ** ./app/query-reports/query-report.ts
 **/